"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  // Main
  father: "#7300a8",
  fatherHover: "#6a1b9a",
  mother: "#00a551",
  motherHover: "#007526",
  // Text
  ghost: "#ffffff",
  swan: "#f5f5f5",
  hare: "#e0e0e0",
  whale: "#9e9e9e",
  wolf: "#727272",
  night: "#333333",
  // Crayons
  sky: "#1cb0f6",
  oceans: "#2b70c9",
  fire: "#fc4848",
  fox: "#ff8f00",
  bee: "#ffcc00",
  kiwi: "#89e219"
};
exports.colors = colors;